export default __webpack_public_path__ + "static/media/pro.30710b62.jpg";